/** @jsx jsx */
import { jsx } from "theme-ui"
import { Component } from "react"
import PropTypes from "prop-types"

import Icon from "../assets/icon"
import NavigationSubItem from "./navigation-sub-item"
import Link from "./link"
import { colors } from "../theme"

class NavigationSubmenu extends Component {
  constructor(props) {
    super(props)
    this.state = {
      open: props.open,
      seoLinks: props.seoLinks,
    }
    this.listNavigationItems = this.listNavigationItems.bind(this)
  }

  static getDerivedStateFromProps(props, state) {
    return { open: props.open }
  }

  listNavigationItems(items) {
    let list = []

    if (!items || items.length === 0) {
      return list
    }
    for (var i = 0; i < items.length; i++) {
      let url = items[i]["url"]["cached_url"]
      if (items[i]["url"]["linktype"] === "story") {
        url =
          items[i]["url"]["story"] && items[i]["url"]["story"]["full_slug"]
            ? items[i]["url"]["story"]["full_slug"]
            : url
      }
      list.push(
        <NavigationSubItem
          key={i}
          displayName={items[i]["displayName"]}
          open={items[i]["open"]}
          currentPage={items[i]["currentPage"]}
          url={url}
          parentOpen={this.state.open}
          navigationItems={items[i]["children"]}
          closeFn={this.props.closeFn}
          accentColor={this.props.accentColor}
          style={this.props.style}
          currentLanguage={this.props.currentLanguage}
          seoLinks={this.state.seoLinks}
        />
      )
    }

    return list
  }

  render() {
    return (
      <div
        className="submenu"
        sx={{
          variant: "navigation.submenu",
          visibility: this.state.open ? "visible" : "hidden",
          transition: " all 400ms ease-out",
          ...this.props.style,
        }}
      >
        <div
          sx={{
            display: "flex",
            flexDirection: "column",
            height: "100%",
            overflowY: "scroll",
          }}
        >
          <div
            className="submenu-navigation"
            sx={{ cursor: "pointer", margin: 15, height: 30, mt: "50px" }}
          >
            {this.props.backFn && (
              <div
                sx={{
                  height: 30,
                  width: 30,
                  float: "left",
                }}
                role="button"
                tabIndex="0"
                onKeyPress={this.props.backFn}
                onClick={this.props.backFn}
              >
                <Icon style={{ fill: "#fff" }} icon="left" />
              </div>
            )}
            <div
              sx={{ height: 25, width: 25, float: "right" }}
              role="button"
              tabIndex="0"
              onKeyPress={this.props.closeFn}
              onClick={this.props.closeFn}
            >
              <Icon style={{ fill: colors.navigation.icon }} icon="close" />
            </div>
          </div>
          <div
            sx={{
              flex: 1,
              flexBasis: "auto",
            }}
          >
            {this.props.url && (
              <div
                sx={{
                  color: colors.navigationText,
                  textAlign: "left",
                  fontSize: 2,
                  padding: 20,
                }}
              >
                <Link
                  to={this.props.url}
                  language={this.props.currentLanguage}
                  seoLinks={this.state.seoLinks}
                  sx={{ color: colors.navigationText, textDecoration: "none" }}
                >
                  <div
                    sx={{
                      mr: "35px",
                    }}
                  >
                    <span
                      sx={{
                        fontWeight: "bold",
                        variant: this.props.currentPage
                          ? "navigation.currentPage"
                          : "navigation.linkbtmbrd",
                      }}
                    >
                      {this.props.displayName}
                    </span>
                  </div>
                </Link>
              </div>
            )}
            {this.listNavigationItems(this.props.navigationItems)}
          </div>
          <div
            sx={{
              flex: 1,
              flexBasis: "auto",
              backgroundColor: this.props.accentColor,
              display:
                this.props.extras && this.props.extras.length > 0
                  ? "block"
                  : "none",
              "& .submenu": {
                backgroundColor: this.props.accentColor,
              },
            }}
          >
            {this.listNavigationItems(this.props.extras)}
          </div>
        </div>
      </div>
    )
  }
}

NavigationSubmenu.defaultProps = {
  seoLinks: {},
}

NavigationSubmenu.propTypes = {
  navigationItems: PropTypes.array.isRequired,
  extras: PropTypes.array,
  closeFn: PropTypes.func,
  open: PropTypes.bool.isRequired,
  displayName: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  accentColor: PropTypes.string,
  style: PropTypes.object,
  currentLanguage: PropTypes.oneOf(["de", "en"]).isRequired,
  seoLinks: PropTypes.object,
}

export default NavigationSubmenu
